// extracted by mini-css-extract-plugin
export default {"Container":"Index_Container__JNczB"};